export default __webpack_public_path__ + "static/media/huma-sevansusnaves-00.5834ccf4.jpg";